import {
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import api  from '../../services/api';


export const useRoleAdd = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body) => {      
      const res = await api.post("/roles/store", body);
      return res;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['viewroles']);
    },
  });

};
